<template>
  <b-container fluid>
    <b-overlay :show="detailsLoader">
      <b-row v-if="accommodation_setup">
        <b-col xl="12" lg="12" sm="12">
          <b-table-simple striped borderless small>
            <b-tr>
              <b-th width="25%">
                {{ $t('elearning_config.accommodation_type') }}
              </b-th>
              <b-td width="75%">
                {{ currentLocale === 'bn' ? accommodation_setup.accommodation_type_bn : accommodation_setup.accommodation_type }}
              </b-td>
            </b-tr>

            <b-tr>
              <b-th width="25%">
                {{ $t('elearning_config.room_name') }}
              </b-th>
              <b-td width="75%">
                {{ currentLocale === 'bn' ? accommodation_setup.room_name_bn : accommodation_setup.room_name }}
              </b-td>
            </b-tr>

            <b-tr>
              <b-th width="25%">
                {{ $t('elearning_config.room_number') }}
              </b-th>
              <b-td width="75%">
                {{ accommodation_setup.room_number }}
              </b-td>
            </b-tr>

            <b-tr>
              <b-th width="25%">
                {{ $t('elearning_config.room_rent') }}
              </b-th>
              <b-td width="75%">
                 {{ accommodation_setup.room_rent }}
              </b-td>
            </b-tr>

            <b-tr>
              <b-th width="25%">
                {{ $t('globalTrans.description') }}
              </b-th>
              <b-td width="75%">
                 {{ currentLocale === 'bn' ? accommodation_setup.description_bn : accommodation_setup.description }}
              </b-td>
            </b-tr>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>
<script>

export default {
  props: ['id'],
  created () {
    if (this.id) {
      const tmp = this.getDataFromStore()
      if (tmp) {
          this.accommodation_setup = tmp
      }
    }
  },
  data () {
    return {
      accommodation_setup: null,
      detailsLoader: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    getDataFromStore () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return tmpData !== undefined ? JSON.parse(JSON.stringify(tmpData)) : null
    }
    /** End Details */
  }
}
</script>
